export enum ConsentSignatureTypeEnum {
  Patient = 0,
  GuardianOrCaregiver = 1,
  Verbal = 2,
}
